import { buildControlPlaneResponse, parseControlPlaneRequest, } from "./control-plane.js";
export const verifyControlPlaneToken = (input) => input.providedToken === input.expectedToken;
export const buildAuthenticatedControlPlaneResponse = async (input) => {
    const request = parseControlPlaneRequest(input.request);
    const authorized = verifyControlPlaneToken({
        expectedToken: input.expectedToken,
        providedToken: request.authToken,
    });
    if (!authorized) {
        throw new Error("auth.unauthenticated");
    }
    input.lifecycle?.onAuthenticated?.();
    return await buildControlPlaneResponse({
        context: input.context,
        lifecycle: input.lifecycle,
        request,
    });
};
